import { Box, Button } from "@mui/material";
import { t } from "i18next";
import { ClientPassportButton } from "../../buttons/ClientPassportButton";
import BaseTable from "../../table/BaseTable";

export function ClientSearchTable(props) {
    // Define headers as strings.
    const headers = [
        "",
        t("clients.ClientSearchTable.firstName"),
        t("clients.ClientSearchTable.lastName"),
        props.includeCompany ? t("clients.ClientSearchTable.companyName") : "",
        t("clients.ClientSearchTable.email"),
        t("clients.ClientSearchTable.phone"),
    ];
    const rows = props.data
        .filter((entry) => entry.id !== props.clientId) // Filter out rows where .id is equal to clientId
        .map((entry) => ({
            rowId: entry.id,
            data: [
                <ClientPassportButton
                    clientId={entry.id}
                    clientType={entry.company ? "company" : "customer"}
                    color="primary"
                />,
                entry.person?.name || "",
                entry.person?.surname || "",
                props.includeCompany ? entry.company?.name : "",
                entry.company
                    ? entry.company?.email?.email_address
                    : entry.person?.email?.email_address,
                entry.company
                    ? entry.company?.phone?.phone_number
                    : entry.person?.phone?.phone_number,
            ],
        }));

    return (
        <Box sx={{ overflow: "auto", ...props.sx }}>
            <BaseTable
                stickyHeader={true}
                headers={headers}
                // @ts-ignore
                rows={rows}
                showEditButton={false}
                showDeleteButton={false}
                sortable={false}
                // ensure no columns are hidden
                hiddenColumns={[]}
                // no row selection for this static table
                selectedRows={[]}
                // @ts-ignore
                renderAction={(row, _) => {
                    return !props.readOnly ? (
                        <Button
                            variant="text"
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                if (props.onCustomerSelected) {
                                    const customer = props.data.find(
                                        (entry) => entry.id === row.rowId,
                                    );
                                    if (customer) {
                                        props.onCustomerSelected(customer);
                                    }
                                }
                                console.log("Action button clicked for row:", row.rowId, row);
                            }}
                        >
                            {t("clients.ClientSearchTable.select")}
                        </Button>
                    ) : null;
                }}
            />
        </Box>
    );
}
